export function getFillFormBreadCrumbs() {
  return [
    {
      label: 'Формы',
      to: '/fillForms'
    }
  ];
}
